import { createDateFormatter, type TimezoneMode } from "@nexus/ui";

export function formatDate(value: string, timezone: TimezoneMode = "utc"): string {
  const ms = Date.parse(value);
  if (!Number.isFinite(ms)) return value;
  return createDateFormatter(timezone, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(ms);
}

export function formatDateTime(value: string, timezone: TimezoneMode = "utc"): string {
  const ms = Date.parse(value);
  if (!Number.isFinite(ms)) return value;
  return createDateFormatter(timezone, {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(ms);
}

export function campaignTitleCase(value: string): string {
  return value.replace(/[_-]+/g, " ").replace(/\b\w/g, (character) => character.toUpperCase());
}

const RESPONSE_TYPE_LABELS: Record<string, string> = {
  ISPBlocking: "BlockingByISPs",
  SuspendedAccount: "SuspendAccounts",
};

export function formatResponseType(value: string): string {
  return RESPONSE_TYPE_LABELS[value] ?? campaignTitleCase(value);
}
